import React, { useLayoutEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import profileStyles from './UserProfile.module.scss';

/**
 * Clamped bio with a See more toggle. Overflow is MEASURED from the DOM, not guessed from string
 * length, and only while clamped — once expanded, scrollHeight === clientHeight and it always reads
 * false. Re-measured on resize because the rail is a percentage width.
 */
const ExpandableSummary = ({ text }: { text?: string }) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const [expanded, setExpanded] = useState(false);
    const [overflows, setOverflows] = useState(false);

    useLayoutEffect(() => {
        const el = ref.current;
        if (!el) return;

        const measure = () => {
            // Only meaningful in the clamped state.
            if (expanded) return;
            setOverflows(el.scrollHeight > el.clientHeight + 1);
        };
        measure();

        if (typeof ResizeObserver === 'undefined') return;
        const ro = new ResizeObserver(measure);
        ro.observe(el);
        return () => ro.disconnect();
    }, [text, expanded]);

    if (!text) return null;

    return (
        <>
            <div ref={ref} className={clsx(profileStyles.ProfileSummary, { [profileStyles.SummaryClamped]: !expanded })}>
                {text}
            </div>
            {(overflows || expanded) && (
                <button type="button" className={profileStyles.SeeMoreBtn} onClick={() => setExpanded((v) => !v)}>
                    {expanded ? 'See less' : 'See more'}
                </button>
            )}
        </>
    );
};

export default ExpandableSummary;
